const archive = {
  layouts: {},
  sizes: {},
  depths: {},
  colors: {}
}

export default archive
